import React from 'react';
import { Page } from '../types';
import { SITE_CONTENT } from '../constants/content';

interface FooterProps {
  navigate: (page: Page) => void;
}

const Footer: React.FC<FooterProps> = ({ navigate }) => {
  const { social } = SITE_CONTENT.common;

  return (
    <footer className="bg-secondary text-white pt-24 pb-12">
      <div className="container mx-auto px-4 md:px-6">
        {/* <div className="mb-20 p-8 md:p-12 rounded-[3.5rem] bg-gradient-to-br from-white/10 to-transparent border border-white/20 flex flex-col md:flex-row items-center justify-between gap-8 shadow-2xl">
          <div className="text-center md:text-left">
            <h3 className="text-2xl md:text-4xl font-black mb-3">Werde Teil der Retter-Community</h3>
            <p className="text-gray-400 max-w-lg text-lg">Wir suchen Entwickler, Mediziner und Helfer, die mit uns die Erste Hilfe digitalisieren möchten.</p>
          </div>
          <button 
            onClick={() => navigate('mitarbeiten')}
            className="whitespace-nowrap bg-primary text-white px-12 py-6 rounded-[2rem] font-black text-xl hover:scale-105 transition-all shadow-xl shadow-primary/30 flex items-center gap-4 group"
            aria-label="Jetzt mitarbeiten und Teil des Teams werden"
          >
            <span>Jetzt Mitarbeiten</span>
            <span className="text-2xl group-hover:rotate-12 transition-transform">🤝</span>
          </button>
        </div> */}

        <div className="mb-20 p-8 md:p-12 rounded-[3.5rem] bg-gradient-to-br from-white/10 to-transparent border border-white/20 flex flex-col md:flex-row items-center justify-between gap-8 shadow-2xl">
          <div className="text-center md:text-left">
            <h3 className="text-2xl md:text-4xl font-black mb-3">Warteliste</h3>
            <p className="text-gray-400 max-w-lg text-lg">Lasse dich jetzt auf die Warteliste setzen und sei einer der ersten, die Erste Hilfe meistern.</p>
          </div>
          <button 
            onClick={() => navigate('warteliste')}
            className="whitespace-nowrap bg-primary text-white px-12 py-6 rounded-[2rem] font-black text-xl hover:scale-105 transition-all shadow-xl shadow-primary/30 flex items-center gap-4 group"
            aria-label="Warteliste beitreten"
          >
            <span>Warteliste</span>
            <span className="text-2xl group-hover:rotate-12 transition-transform">🤝</span>
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-16 mb-20">
          <div className="col-span-1">
             <button onClick={() => navigate('start')} className="flex items-center space-x-3 mb-8 group text-left outline-none" aria-label="Zur Startseite">
                <div className="relative w-12 h-12 flex-shrink-0">
                  <svg viewBox="0 0 100 100" className="w-full h-full">
                    <path d="M35 25 C35 15, 65 15, 65 25" fill="none" stroke="#ee223b" strokeWidth="8" strokeLinecap="round" />
                    <rect x="15" y="30" width="70" height="60" rx="20" fill="#ee223b" />
                    <rect x="44" y="45" width="12" height="30" rx="3" fill="white" />
                    <rect x="35" y="54" width="30" height="12" rx="3" fill="white" />
                  </svg>
                </div>
                <div className="flex flex-col">
                  <span className="text-xl font-extrabold tracking-tighter leading-none">ErsteHilfe</span>
                  <span className="text-xl font-black tracking-tighter text-primary leading-none">2Go</span>
                </div>
             </button>
             <p className="text-gray-400 mb-8 text-sm leading-relaxed">
                Die moderne Plattform für Erste-Hilfe-Wissen in Deutschland. Wir machen Lebensrettung zum Standard.
             </p>
             <div className="flex space-x-4">
                <a 
                  href={social.instagram} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="w-10 h-10 bg-white/5 rounded-xl flex items-center justify-center cursor-pointer hover:bg-primary transition-all"
                  title="Instagram"
                >
                  📸
                </a>
                <a 
                  href={social.linkedin} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="w-10 h-10 bg-white/5 rounded-xl flex items-center justify-center cursor-pointer hover:bg-primary transition-all"
                  title="LinkedIn"
                >
                  💼
                </a>
             </div>
          </div>
          
          <div>
            <h4 className="font-bold text-lg mb-8">Navigation</h4>
            <ul className="space-y-4 text-gray-400 text-sm">
              <li><button onClick={() => navigate('start')} className="hover:text-primary transition-colors">Startseite</button></li>
              <li><button onClick={() => navigate('ueber-uns')} className="hover:text-primary transition-colors">Über uns</button></li>
              <li><button onClick={() => navigate('warteliste')} className="hover:text-primary transition-colors">Warteliste</button></li>
              <li><button onClick={() => navigate('funktionen')} className="hover:text-primary transition-colors">Funktionen</button></li>
              <li><button onClick={() => navigate('status')} className="hover:text-primary transition-colors">Projektstatus</button></li>
              <li><button onClick={() => navigate('wissenshub')} className="hover:text-primary transition-colors">WissensHub</button></li>
              {/* <li><button onClick={() => navigate('mitarbeiten')} className="hover:text-primary transition-colors">Mitarbeiten</button></li> */}
              <li><button onClick={() => navigate('blog')} className="hover:text-primary transition-colors">Blog</button></li>
              <li><button onClick={() => navigate('faq')} className="hover:text-primary transition-colors">FAQ</button></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-8">Rechtliches</h4>
            <ul className="space-y-4 text-gray-400 text-sm">
              <li><button onClick={() => navigate('impressum')} className="hover:text-primary transition-colors">Impressum</button></li>
              <li><button onClick={() => navigate('datenschutz')} className="hover:text-primary transition-colors">Datenschutz</button></li>
              <li><button onClick={() => navigate('medizinische-transparenz')} className="hover:text-primary transition-colors">Medizinische Transparenz</button></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-8">Kontakt</h4>
            <p className="text-gray-400 mb-4 text-sm">
              Fragen zum Projekt?<br />
              <a href={`mailto:${SITE_CONTENT.common.contactEmail}`} className="text-white font-bold hover:text-primary transition-colors">{SITE_CONTENT.common.contactEmail}</a>
            </p>
            <div className="bg-white/5 p-5 rounded-2xl border border-white/5">
               <p className="text-[10px] text-gray-400 italic leading-relaxed">
                 Medizinischer Hinweis: Die App ersetzt im akuten Notfall niemals den Notruf 112. Handeln Sie nach bestem Wissen und Gewissen.
               </p>
            </div>
          </div>
        </div>
        
        <div className="pt-10 border-t border-white/5 flex flex-col md:flex-row justify-between items-center text-[10px] text-gray-500 font-bold uppercase tracking-widest gap-4">
           <p>© 2026 {SITE_CONTENT.common.appName}. Alle Rechte vorbehalten.</p>
           <p>Made for a safer future in Germany.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
